import React from 'react';
import { Link } from 'react-router-dom';

import AOS from 'aos';
import 'aos/dist/aos.css';

import Form from './Form';

AOS.init({
    duration: 1200
});

export default function CallAction() {
    const handleContactClick = () => {
        window.dispatchEvent(new Event("scrollToForm"));
    };
    return (
        <div className='call-cont'>
            <div className='container-fluid sectin'>
                <div className='row'>
                    <div className='col-md-9 col-18 ca-lt-ct mb-0'>
                        <div className='mxw-400' data-col="eq-htm">
                            <h2 className='h1 txt-lt fw-300 mb-8' data-aos="fade-down" data-aos-once='true'>Ready to build something extraordinary?</h2>
                            <p className='f-18 mb-8 line-ht-24' data-aos="fade-up" data-aos-once='true' data-aos-delay="400">Connect with us and let's turn your ideas into impactful, future-ready digital experiences—together.</p>
                            <div data-aos="fade-up" data-aos-once='true' data-aos-delay="400"><Link className="glow-btn" onClick={handleContactClick}><span>Contact Us</span></Link></div>
                        </div>
                    </div>
                    <div className='col-md-9 col-18 ca-rt-ct mb-0'>
                        <div className='mxw-400 m-auto' data-col="eq-htm" data-aos="fade-left" data-aos-once='true' data-aos-delay="600"><Form /></div>
                    </div>
                </div>
            </div>
        </div>
    )
}
